import React, { useEffect, useState } from 'react';
import '../css/navBar.css'
import '../css/hamburger.css'
import logo from '../assets/logoUnion.png';
import notificaciones from '../assets/Notificaciones.png';
import notificacionesActivas from '../assets/notificacionActivaRojo.png';
import flechaSelect from '../assets/flechaSelect.png';
//import imagenPerfil from '../assets/portada.jpeg';
import salir from '../assets/salida.png';
//import iconoEventos from '../assets/eventos.png';
import iconoEventos from '../assets/logoCalendario.png';
//import iconoPerfil from '../assets/perfil.png';
import iconoPerfil from '../assets/perfil.png';
//import iconoActividades from '../assets/actividades.png';
import iconoActividades from '../assets/logoReuniones.png';
//import iconoEmpresas from '../assets/empresas.png';
import iconoEmpresas from '../assets/logoEmpresas.png';
import { cerrarSesion } from '../funciones.js';
import Notificaciones from './Notificaciones.js';
import { handleError, toastError, toastInfo } from '../funciones';
import axios from '../axiosConfig';


function NavBar(props) {


    const [visto, setVisto] = useState(false);
    useEffect(() => {
        let url = window.location.pathname;

        const tabs = ["empresas", "actividades", "eventos"];

        tabs.forEach(e => {
            if (!e.localeCompare("eventos")) {
                if (!url.localeCompare("/")) {
                    setActive("tab-mov-" + e);
                    setActive("tab-" + e);
                }
            }
            else if (!url.localeCompare("/" + e)) {
                setActive("tab-mov-" + e);
                setActive("tab-" + e);
            }

        });

        function setActive(id) {
            document.getElementById(id).classList.add("active");
        }
       
        if(((window.screen.availWidth <= 880 || (window.screen.availHeight >= 901 && window.screen.availWidth <= 991)))&& window.screen.availWidth >= 575){
            const navMobile = document.getElementById('navMobile');
            const empresaNav = document.getElementById('empresaNav');
            const notifNav = document.getElementById('notifNav');
            /*document.getElementById('navbar-nav').style.width =  " calc(" + navMobile.scrollWidth + "px + 3rem)";*/
            notifNav.style.marginLeft = "calc(" +  (navMobile.scrollWidth - empresaNav.scrollWidth - notifNav.scrollWidth) + "px )"; 
           
        }
    }, [])
    function mostrarNotificaciones() {
        if (document.getElementById('notificaciones').classList.contains('d-none')) {

            document.getElementById('notificaciones').classList.remove('d-none');
            if (!visto) {
                setVisto(true);
                const params = {
                    params: {
                        empresaId: localStorage.getItem(process.env.REACT_APP_ID_EMPRESA)
                    }
                }
                axios
                    .put(process.env.REACT_APP_URL + 'empresa/actualizarUltimaVez', null, params)
                    .then((res) => {

                    })
                    .catch(function (error) {
                        toastError(handleError(error))
                    })
            }
        }

        else
            document.getElementById('notificaciones').classList.add('d-none');

    }
    function mostrarNavMobile(){
        if(!localStorage.getItem(process.env.REACT_APP_NAVBAR_ACTIVA)){
            localStorage.setItem(process.env.REACT_APP_NAVBAR_ACTIVA, 1) 
            const hamburger = document.getElementById('hamburger')
            const navMobile = document.getElementById('navMobile');
            const empresaNav = document.getElementById('empresaNav');
            const notifNav = document.getElementById('notifNav');
            notifNav.style.transition = "all 2s"; 
            /*document.getElementById('empresaNav').classList.toggle('d-none')
            document.getElementById('notifNav').classList.toggle('d-none')*/
            if(!hamburger.classList.contains('open')){
                navMobile.style.width = navMobile.scrollWidth + "px"; 
                notifNav.style.marginLeft = " calc(-" + (empresaNav.scrollWidth + notifNav.scrollWidth) + "px - 1rem)";
                document.getElementById('navbar-nav').classList.add("overflow-hidden");
                localStorage.removeItem(process.env.REACT_APP_NAVBAR_ACTIVA) 
            }
            else{
                notifNav.style.marginLeft = "calc(" +  (navMobile.scrollWidth - empresaNav.scrollWidth - notifNav.scrollWidth) + "px )"; 
                new Promise(resolve => setTimeout(resolve, 1000)).then(() => { 
                    document.getElementById('navbar-nav').classList.remove("overflow-hidden");
                    localStorage.removeItem(process.env.REACT_APP_NAVBAR_ACTIVA) 

                });
                //notifNav.style.marginLeft = " calc(" + (navMobile.scrollWidth) + "px - 1rem)";

                navMobile.style.width = 0 + "px";
            }
            hamburger.classList.toggle('open')
        }
    }
    return (
        <>

            <nav id="navBar" class="navbar navbar-expand-lg pb-4 pt-5  navBarLogueado">
                <div class="container container-width-85">
                    <a class="navbar-brand" href="/">
                        <img src={logo} alt="" />
                    </a>
                    <div class="d-flex">
                        <div class="collapse navbar-collapse z-10" id="navbarNavDropdown">
                            <ul id="navbar-nav" class="navbar-nav ">
                                <li class="nav-item ocultarNavMoobile centrarContainer" >
                                    <a id="tab-eventos" class="nav-link text-white me-3 px-0 pb-1 subrayado pt-0" aria-current="page" href="/">Eventos</a>
                                </li>
                                <li class="nav-item ocultarNavMoobile centrarContainer" >
                                    <a id="tab-empresas" class="nav-link text-white mx-3 px-0 pb-1 subrayado pt-0" href="/empresas">Lista de empresas</a>
                                </li>
                                <li class="nav-item  ocultarNavMoobile centrarContainer" >
                                    <a id="tab-actividades" class="nav-link text-white mx-3 px-0 pb-1 subrayado pt-0" href="/actividades">Mis actividades</a>
                                    
                                </li>
                                <li id="notifNav" class="nav-item logoNotificaciones ">
                                    <div className='position-relative'>
                                        <Notificaciones notificaciones={props.notificaciones} />
                                    </div>
                                    <div className='centrarContainer h-100 pb-1'>
                                        <div class=" mx-3 px-0 cursor-pointer" >
                                            {props.notificaciones.length > 0 && props.ultimaVez <= props.notificaciones[0].fecha && !visto ?

                                                <img src={notificacionesActivas} alt="" onClick={mostrarNotificaciones} id="botonNotificaciones" />
                                                :

                                                <img src={notificaciones} alt="" onClick={mostrarNotificaciones} id="botonNotificaciones" />
                                            }

                                        </div>
                                        <img src={salir} className='mostrarMobile d-none mx-3 cursor-pointer' alt="" onClick={cerrarSesion} />
                                    </div>
                                </li>
                                <li id="empresaNav" class="nav-item dropdown ms-3 centrarContainer ocultarMobile" >
                                    <a class="nav-link dropdown-toggle text-white centrarContainer px-0" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                        {props.logo ? 
                                            <img id="imagenPerfil" className='me-2 rounded-circle' src={require("../assets/rubros/" + props.logo)} alt="" />
                                        : 
                                            <div id="imagenPerfil" className='me-2 rounded-circle bg-transparent'  alt="" />
                                        }
                                        {/*<div id="imagenPerfil" className='me-2 rounded-circle centrarContainer' alt="" >
                                            <div className='text-white text-center w-100 '>{localStorage.getItem(process.env.REACT_APP_NOMBRE_EMPRESA).charAt(0).toUpperCase()}</div>
                                           
                                        </div>*/}
                                        <div id="nombrePerfilNavBar">{localStorage.getItem(process.env.REACT_APP_NOMBRE_EMPRESA)}</div>
                                        <img className='mx-2 flechaDropdown' src={flechaSelect} alt="" />
                                    </a>
                                    <ul class="dropdown-menu rounded-3">
                                        <li><a id='abrirPerfil' class="dropdown-item" href="#" data-bs-toggle="modal" data-bs-target="#modalMiPerfil">Mi perfil</a></li>
                                        <li><a class="dropdown-item" href="#" data-bs-toggle="modal" data-bs-target="#modalCodigo">Cambiar contraseña</a></li>
                                        <li><a class="dropdown-item" href="#" onClick={() => cerrarSesion(true)}>Cerrar sesión</a></li>
                                    </ul>
                                </li>  
                                <li id="navMobile" class="nav-item  centrarContainer ocultarMobile navMobile" >
                                    <a id="tab-mov-eventos" class="nav-link text-white mx-3 px-0 pb-1 subrayado pt-0" href="/">Eventos</a>
                                    <a id="tab-mov-empresas" class="nav-link text-white mx-3 px-0 pb-1 subrayado pt-0" href="/empresas">
                                    <div className='txt-nav-empresas'>Lista de empresas</div>
                                    <div className='txt-nav-empresas-mobile d-none'>Empresas</div></a>
                                    <a id="tab-mov-actividades" class="nav-link text-white mx-3 px-0 pb-1 subrayado pt-0" href="/actividades">Mis actividades</a>
                                    
                                </li> 
                                <li class="nav-item dropdown ms-2 d-none navToggle ocultarMobile centrarContainer" >

                                    <div class="nav-link dropdown-toggle text-white centrarContainer px-0" 
                                     onClick={mostrarNavMobile}>{/*role="button"data-bs-toggle="dropdown" aria-expanded="false"*/} 
                                        {/*<button class="navbar-toggler  dropdown-toggle " type="button">
                                            <span class="navbar-toggler-icon"></span>
                                        </button>*/}
                                        <div id="hamburger" className='centrarContainer'>
                                            <button>
                                            <span className='top-line'></span>
                                            <span className='middle-line'></span>
                                            <span className='bottom-line'></span>
                                            </button>
                                        </div>
                                    </div>
                                    {/*<ul class="dropdown-menu rounded-3">
                                        <li><a class="dropdown-item" aria-current="page" href="/">Eventos</a></li>
                                        <li><a class="dropdown-item" href="/empresas">Lista de empresas</a></li>
                                        <li><a class="dropdown-item" href="/actividades">Mis actividades</a></li>

                                    </ul>*/}
                                </li>

                            </ul>


                        </div>

                    </div>
                </div>
                <div id='navbarMobile' className='container position-fixed bottom-0 end-0 start-0  navbarMobile d-none'>
                    <div className='row text-center w-100 mx-auto'>
                        <div className='col  py-3'>
                            <a id='tab-cel-eventos' class="nav-link text-white px-0" aria-current="page" href="/">
                                <img className='mb-1 imagenNavPerfil img-blanco-mobile' src={iconoEventos} alt="" />
                                <div>Eventos</div>
                            </a>
                        </div>
                        <div className='col  py-3'>
                            <a id='tab-cel-empresas' class="nav-link text-white px-0" aria-current="page" href="/empresas">
                                <img className='mb-1 imagenNavPerfil img-blanco-mobile' src={iconoEmpresas} alt="" />
                                <div>Empresas</div>
                            </a>
                        </div>
                        <div className='col  py-3'>
                            <a id='tab-cel-actividades' class="nav-link text-white px-0" aria-current="page" href="/actividades">
                                <img className='mb-1 imagenNavPerfil img-blanco-mobile' src={iconoActividades} alt="" />
                                <div>Actividades</div>
                            </a>
                        </div>
                        <div className='col py-3'>
                            <a id='tab-cel-profile' class="nav-link text-white px-0" aria-current="page" href="/" data-bs-toggle="modal" data-bs-target="#modalMiPerfil">
                                <img className='mb-1 imagenNavPerfil' src={iconoPerfil} alt="" />
                                <div>Perfil</div>
                            </a>
                        </div>
                    </div>
                </div>
            </nav>

        </>
    );
}


export default NavBar;